import React, { useEffect, useState } from "react";
import CommonGrid from "../../components/CommonGrid";
import { gridColumnAdminMenu } from "../../Utils/TableColumnDefs";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import Heading from "../../components/Heading";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { useDispatch, useSelector } from "react-redux";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import { selected_authentication_server } from "../../deployment-config";
import { setMasquerade } from "../../store/reducers/reducer-auth";
import { useSetUserLoggedIn } from "../Login/LoginComp";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Button";
import { useAbortController } from "../../hooks/useAbortController";

const AdminMenu = () => {
  const [adminMenuTable, setAdminMenuTable] = useState([]);
  const [loading, setLoading] = useState("loading");
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.label
  );
  const navigate = useNavigate();
  const { signal } = useAbortController();

  useEffect(() => {
    // setAdminMenuTable(null);
    const fetchData = async () => {
      const config = {
        headers: {
          user_id: `${localStorage.getItem("apex_userid")}`,
          Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
        },
      };
      const res = await axios.get(
        urls.admin.manageUser,
        // "https://api-p.loanlinq.com/ords/loanlinq/v1/manageuser",
        config,
        { signal }
      );
      let data = res.data.items;
      // const newdata = data.filter(item => item.role_name.toLowerCase().includes("admin"))
      setAdminMenuTable(data);
      setLoading("fulfilled");
    };
    fetchData();
  }, []);
  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Admin Menu" />,
      role: ["Both"],
      className: "col-sm-6 px-4",
    },
    {
      component: (
        <Button
          onClick={() => navigate("/admin-menu/Create")}
          text="Add User"
          className="admin-menu-button"
        />
      ),
      role: ["Both"],
      className: "col-sm-6 px-4 text-end",
    },
    {
      component: (
        <CommonGrid
          className={"bg-white col-sm-12 admin-menu-table"}
          tHeight={"68vh"}
          title={"Admin Menu"}
          gridColumns={gridColumnAdminMenu}
          columnData={adminMenuTable}
          status={loading}
        />
      ),
      role: ["Both"],
      className: "col-sm-12 px-4 mt-5",
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid row">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};

export default AdminMenu;
// export const AddAccountForm = ({ update, row }) => {
//   const { register, handleSubmit, watch, setValue } = useForm({
//     defaultValues: row,
//   });
//   const disabled = JSON.stringify(row) === JSON.stringify(watch());
//   const accountOptions = useSelector((state) => state.account.accountOptions);
//   const handleSub = async (data) => {
//     if (update) {
//       const headers = {
//         headers: {
//           user_id: `${localStorage.getItem("apex_userid")}`,
//         },
//       };
//       const res = await axios.post(
//         urls.dashboard.getUserManagement(),
//         {
//           USER_ID: `${data.user_id}`,
//           FIRST_NAME: data.firstName,
//           LAST_NAME: data.lastName,
//           USERNAME: data.email,
//           EMAIL: data.email,
//           MOBILE: data.mobile,
//           IS_ACTIVE: data.status.value,
//           ROLE: data.role_name.value,
//           ACTION: "I",
//           ACCOUNTS: data.account_name?.map((data) => data.value),
//           CREATED_BY_USER_ID: `${localStorage.getItem("apex_userid")}`,
//         },
//         headers
//       );
//     } else {
//       const headers = {
//         headers: {
//           user_id: `${localStorage.getItem("apex_userid")}`,
//         },
//       };
//       const res = await axios.post(
//         urls.dashboard.getUserManagement(),
//         {
//           USER_ID: `${data.user_id}`,
//           FIRST_NAME: data.firstName,
//           LAST_NAME: data.lastName,
//           USERNAME: data.email,
//           EMAIL: data.email,
//           MOBILE: data.mobile,
//           IS_ACTIVE: data.status.value,
//           ROLE: data.role_name.value,
//           ACTION: "I",
//           ACCOUNTS: data.account_name?.map((data) => data.value),
//           CREATED_BY_USER_ID: `${localStorage.getItem("apex_userid")}`,
//         },
//         headers
//       );
//     }
//   };
//   return (
//     <div>
//       <FormBox
//         options={[
//           {
//             title: "First Name",
//             field: "firstName",
//             type: "text",
//           },
//           {
//             title: "Last Name",
//             field: "lastName",
//             type: "text",
//           },
//           {
//             title: "Email",
//             field: "email",
//             type: "text",
//           },
//           {
//             title: "Mobile",
//             field: "mobile",
//             type: "text",
//           },
//           {
//             title: "Role",
//             field: "role_name",
//             type: "select",
//             options: [
//               {
//                 label: "Lender",
//                 value: "LENDER",
//               },
//               {
//                 label: "Broker",
//                 value: "BROKER",
//               },
//               {
//                 label: "Lender Admin",
//                 value: "LENDER_ADMIN",
//               },
//               {
//                 label: "Broker Admin",
//                 value: "BROKER_ADMIN",
//               },
//             ],
//           },
//           {
//             title: "Account Name",
//             field: "account_name",
//             type: "select",
//             isMulti: true,
//             options: accountOptions,
//             dependsOn: [
//               {
//                 field: "role_name",
//                 value: "LENDER",
//               },
//               {
//                 field: "role_name",
//                 value: "BROKER",
//               },
//             ],
//             dependsType: "any",
//           },
//           {
//             field: "status",
//             title: "Activated",
//             type: "select",
//             options: [
//               {
//                 label: "Active",
//                 value: "Y",
//               },
//               {
//                 label: "Inactive",
//                 value: "N",
//               },
//             ],
//           },
//         ]}
//         register={register}
//         watch={watch}
//         setValue={setValue}
//       />
//       <button
//         className="btn btn-primary mt-2"
//         disabled={disabled}
//         onClick={handleSubmit(handleSub)}
//       >
//         {update ? "Update" : "Add Account"}
//       </button>
//     </div>
//   );
// };
export const EditMenu = ({ props }) => {
  const row = props?.row?.original;
  const navigate = useNavigate();

  // const updatedRow = {
  //   ...row,
  //   status:
  //     row.status === "Y"
  //       ? { label: "Active", value: row.status }
  //       : { label: "Inactive", value: row.status },
  //   role_name: { label: row.role_name, value: row.role_name },
  // };

  return (
    <>
      <button
        className="btn btn-primary"
        onClick={() => navigate(`/admin-menu/Update/${row.user_id}`)}
      >
        Edit
      </button>
    </>
  );
};
export const MasqueradeButton = ({ props }) => {
  const row = props?.row?.original;
  const setUserLoggedIn = useSetUserLoggedIn();
  const dispatch = useDispatch();
  const handleMasquerade = async () => {
    localStorage.setItem("backToOrigin", localStorage.getItem("apex_userid"));
    const res2 = await axios.post(
      selected_authentication_server.access_account.endpoint,
      { userid: row.user_id },
      selected_authentication_server.access_account.headers
    );
    setUserLoggedIn({ res: res2 });
    dispatch(
      setMasquerade({
        isIt: true,
        p_logged_in_email: localStorage.getItem("email_for_forgot_password"),
        p_session: "",
        p_ticket_id: "",
      })
    );
  };
  return (
    <>
      <button className="btn btn-primary" onClick={handleMasquerade}>
        Masquerade
      </button>
    </>
  );
};
